export let SignupQueryKeys;

(function (SignupQueryKeys) {
  SignupQueryKeys["Intent"] = "intent";
  SignupQueryKeys["OptSidebar"] = "opt_sidebar";
  SignupQueryKeys["ViralSourcePortalId"] = "viralSourcePortalId";
  SignupQueryKeys["SignupMode"] = "signupMode";
})(SignupQueryKeys || (SignupQueryKeys = {}));